import { TranslationService } from "../../../services/TranslationService";

export function getLinkTo(link: string) {
  return "/" + TranslationService.currentLanguage + "/" + link;
}
